import {
  applyMiddleware,
  createStore,
  Middleware,
  AnyAction,
  Dispatch,
} from "redux";
import createSagaMiddleware from "redux-saga";
import { createLogger } from "redux-logger";

import rootReducer from "../reducers/index.reducer";
import rootSaga from "../sagas/index.saga";
import { IInitialState } from "../types/initialState.types";

const configureStore = (state: IInitialState) => {
  const sagaMiddleware = createSagaMiddleware();
  const middleware: Middleware[] = [sagaMiddleware];

  const enableReduxLoggerByLocalStorage = JSON.parse(
    localStorage.getItem("enableReduxLogger") ?? "false",
  ) as boolean;

  if (
    process.env.REACT_APP_ENV === "development" ||
    process.env.NODE_ENV === "development" ||
    enableReduxLoggerByLocalStorage
  ) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/ban-types
    const logger: Middleware<{}, any, Dispatch<AnyAction>> = createLogger({
      collapsed: true,
      duration: true,
      // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
    }) as Middleware<{}, any, Dispatch<AnyAction>>;
    middleware.push(logger);
  }

  const store = createStore(rootReducer, state, applyMiddleware(...middleware));
  sagaMiddleware.run(rootSaga);
  return store;
};

export default configureStore;
